import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import CreateNewRfidForm from '../../../../Componant/Application/Project/master/CreateNewRfidForm'


const RfidCreateContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <CreateNewRfidForm />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default RfidCreateContainer